module.exports = __webpack_public_path__ + "static/media/Gears.f01e785e.webp";